module.exports = __webpack_public_path__ + "fonts/Gibson-Light.db4b0e17.woff";